import React, { Suspense } from "react";
import LoadingPage from "components/LoadingPage";
import NotFound from "pages/404";
import PrivateRoute from "./PrivateRoute";

import { Switch, Route } from "react-router-dom";
import { mockupRouter } from "./path";

const Routes = () => (
	<Suspense fallback={<LoadingPage />}>
		<Switch>
			{mockupRouter.map(route => {
				return (
					<PrivateRoute
						exact
						key={route.type}
						path={route.path}
						type={route.type}
						isAuth={route.isAuth}
					/>
				);
			})}
			<Route path="*" component={NotFound} />
		</Switch>
	</Suspense>
);

export default Routes;
